import React from 'react'
import { Box, Button, FileViewer } from '@/components/lib'
import { FaFile } from 'react-icons/fa'

import FileChooser from '../includes/FileChooser'

export default function File ({ dataType, value, onChange, participant }) {
  return (
    <Box>
      {!value?.fileName &&
        <FileChooser
          accept='.doc,.docx,application/msword,.pdf,.xls,.xlsx,.ppt,.pptx,.pages,.numbers,.key,.txt'
          forType='participant' forObject={participant}
          onComplete={({ storedName, name, expectedUrl }) => onChange({ name, fileName: storedName, url: expectedUrl })}
          trigger={<Button size='sm' variant='outline' colorPalette='primary'><Box as={FaFile} mr={2} /> Choose a file</Button>}
        />}
      {value?.url &&
        <FileViewer url={value.url} name={value.fileName} displayName={value.name} onRemove={() => onChange('')} />}
    </Box>
  )
}
